import "./CSS/theme.css";
import "./App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home";
import products from "./Components/ProductPage/products";
import ScrollToTop from "./Components/script/script";

// Pages other than the home page are loaded only when visited.
const Contact = lazy(() => import("./Components/Contact/contact"));
const Readmore = lazy(() => import("./Components/ReadMore/Readmore"));
const OurProducts = lazy(() => import("./Components/OurProducts/product"));
const CompanyProfile = lazy(() => import("./Components/CompanyProfile/company"));
const ProductPage = lazy(() => import("./Components/ProductPage/ProductPage"));
const NotFound = lazy(() => import("./Components/NotFound/NotFound"));

// Disabled product pages (not converted to ProductPage yet):
// Components/ProductCards/Openable System/fixedopenable.js          (/fixedopenable)
// Components/ProductCards/Window/SlidingWindowMesh.js               (/slidingwindowmesh)
// Components/ProductCards/Window/SingleSliderWithTrack.js           (/singlesliderwithtrack)
// Components/ProductCards/Openable System/OpenableMultiFold.js      (/openablemultifolddoor)

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contactus" element={<Contact />} />
          <Route path="/Readmore" element={<Readmore />} />
          <Route path="/ourproducts" element={<OurProducts />} />
          <Route path="/companyprofile" element={<CompanyProfile />} />
          {products.map((product) => (
            <Route
              key={product.path}
              path={product.path}
              element={<ProductPage key={product.path} product={product} />}
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
